/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Highlights_Matched_TitleInputs */

const en_us2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Against the last workout of the same muscles`)
};

const pt_br2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contra o último treino dos mesmos músculos`)
};

const es_419_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frente al último entrenamiento de los mismos músculos`)
};

const pt_pt2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Face ao último treino dos mesmos músculos`)
};

const fr_fr2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par rapport à la dernière séance des mêmes muscles`)
};

const de_de2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Vergleich zum letzten Training derselben Muskeln`)
};

const it_it2_workout_highlights_matched_title = /** @type {(inputs: Workout_Highlights_Matched_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispetto all'ultimo allenamento degli stessi muscoli`)
};

/**
* | output |
* | --- |
* | "Against the last workout of the same muscles" |
*
* @param {Workout_Highlights_Matched_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_matched_title = /** @type {((inputs?: Workout_Highlights_Matched_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Matched_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_matched_title(inputs)
	if (locale === "es-419") return es_419_workout_highlights_matched_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_matched_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_matched_title(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_matched_title(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_matched_title(inputs)
	return en_us2_workout_highlights_matched_title(inputs)
});
export { workout_highlights_matched_title as "workout-highlights.matched_title" }